<template>
  <div class="provider-countries" :title="countriesTitle">
    {{ countriesLabel }}
  </div>
</template>

<style scoped>
  .provider-countries {
    display: flex;
    align-items: center;
    color: #646a70;
    padding: 0 8px;
    max-width: 200px;
    margin-right: 16px;
    white-space: nowrap;
    height: 100%;
    border-radius: 4px;
    border: 1px solid #EAEDEF;
    background-color: white;
  }

</style>

<script>
export default {
  name: 'provider-countries-view',
  props: {
    discountCountries: {
      type: Array,
      required: true,
    },
    countries: {
      type: Array,
      required: true,
    },
  },
  computed: {
    hasCountries() {
      return this.discountCountries.length !== 0;
    },
    countriesLabel() {
      if (this.discountCountries.length > 1) {
        return `${this.discountCountries.length} countries`;
      }
      if (this.discountCountries.length === 1) {
        return this.countries.find((item) => item.countryGeoId === this.discountCountries[0]).name;
      }
      return '';
    },
    countriesTitle() {
      if (this.discountCountries.length > 1) {
        const countryNames = [];
        this.discountCountries.forEach((countryGeoId) => {
          const country = this.countries.find((item) => item.countryGeoId === countryGeoId);
          if (country != null) {
            countryNames.push(country.name);
          }
        });
        return countryNames.sort().join(', ');
      }
      return null;
    },
  },
};
</script>
